var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-8 left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.companyinfo")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          !_vm.edited && _vm.ready
            ? [
                _c("div", { staticClass: "click-to-shake" }, [
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.general") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.logo")))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          position: "relative",
                                          "/*background":
                                            "rgba(216, 226, 231, .25)"
                                        }
                                      },
                                      [
                                        [
                                          _vm.shopInfo.logo.original
                                            ? _c("img", {
                                                staticClass:
                                                  "col-12 img-thumbnail",
                                                staticStyle: {
                                                  padding: "5px",
                                                  "max-width": "158px"
                                                },
                                                attrs: {
                                                  src:
                                                    _vm.shopInfo.logo.original
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "col-12 img-thumbnail",
                                                staticStyle: {
                                                  padding: "5px",
                                                  "max-width": "158px"
                                                },
                                                attrs: {
                                                  src: _vm.defaultImages.product
                                                }
                                              })
                                        ]
                                      ],
                                      2
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.shopname")) + " *"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.shop_name,
                                      expression: "form.shop_name"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: _vm.form.shop_name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "shop_name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.business") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.form")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.info.business.form_id,
                                        expression: "form.info.business.form_id"
                                      }
                                    ],
                                    staticClass: "custom-select form-control",
                                    attrs: { disabled: "" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form.info.business,
                                          "form_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("placeholder.select"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "1" } }, [
                                      _vm._v(_vm._s(_vm.$t("business.form.1")))
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "2" } }, [
                                      _vm._v(_vm._s(_vm.$t("business.form.2")))
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.type")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.info.business.type_id,
                                        expression: "form.info.business.type_id"
                                      }
                                    ],
                                    staticClass: "custom-select form-control",
                                    attrs: { disabled: "" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form.info.business,
                                          "type_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("placeholder.select"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "1" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.1"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "2" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.2"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "3" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.3"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "4" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.4"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "5" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.5"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "6" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.6"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "7" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.7"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "8" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.8"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "9" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.9"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "10" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.10"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "11" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.11"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 1
                                      ? _c(
                                          "option",
                                          { attrs: { value: "12" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("business.type.12"))
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 2
                                      ? _c(
                                          "option",
                                          { attrs: { value: "101" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("business.type.101")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 2
                                      ? _c(
                                          "option",
                                          { attrs: { value: "102" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("business.type.102")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id == 2
                                      ? _c(
                                          "option",
                                          { attrs: { value: "103" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("business.type.103")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.info.business.form_id > 0
                                      ? _c(
                                          "option",
                                          { attrs: { value: "300" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("business.type.300")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.about")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-textarea", {
                                    attrs: { rows: 3, disabled: "" },
                                    model: {
                                      value: _vm.form.info.business.about,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.info.business,
                                          "about",
                                          $$v
                                        )
                                      },
                                      expression: "form.info.business.about"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.vat") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.vatregistration"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "box-input active" },
                                  [
                                    _c(
                                      "vs-checkbox",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          position: "relative",
                                          top: "1px",
                                          left: "-5px"
                                        },
                                        attrs: {
                                          disabled: true,
                                          color: "#A3CA76"
                                        },
                                        model: {
                                          value: _vm.form.info.vat.is_active,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.info.vat,
                                              "is_active",
                                              $$v
                                            )
                                          },
                                          expression: "form.info.vat.is_active"
                                        }
                                      },
                                      [
                                        [
                                          _vm.form.info.vat.is_active
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("message.yes"))
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("message.no"))
                                                )
                                              ])
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.taxpayerno")))
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.info.vat.taxpayer_no,
                                      expression: "form.info.vat.taxpayer_no"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: _vm.form.info.vat.taxpayer_no
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.info.vat,
                                        "taxpayer_no",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.location") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.country")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.form.info.location.country_code,
                                        expression:
                                          "form.info.location.country_code"
                                      }
                                    ],
                                    staticClass: "custom-select form-control",
                                    attrs: { disabled: "" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form.info.location,
                                          "country_code",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("placeholder.select"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "TH" } }, [
                                      _vm._v(_vm._s(_vm.$t("countries.th")))
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.address")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-textarea", {
                                    attrs: { rows: 3, disabled: "" },
                                    model: {
                                      value: _vm.form.info.location.address,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.info.location,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression: "form.info.location.address"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.contacts") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.tel")))
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contacts.tel,
                                      expression: "form.contacts.tel"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: _vm.form.contacts.tel },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.contacts,
                                        "tel",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.email")))
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contacts.email,
                                      expression: "form.contacts.email"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: _vm.form.contacts.email },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.contacts,
                                        "email",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.socialmedia") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.website")))
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contacts.website,
                                      expression: "form.contacts.website"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: _vm.form.contacts.website
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.contacts,
                                        "website",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("socialmedia.facebook")))
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contacts.facebook,
                                      expression: "form.contacts.facebook"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: _vm.form.contacts.facebook
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.contacts,
                                        "facebook",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("socialmedia.youtube")))
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contacts.youtube,
                                      expression: "form.contacts.youtube"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: _vm.form.contacts.youtube
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.contacts,
                                        "youtube",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.edited
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.general") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-2" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.logo")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    [
                                      _vm.form.isShowFilePond == true
                                        ? _c("file-pond", {
                                            ref: "pond",
                                            attrs: {
                                              server: {
                                                process: _vm.process,
                                                revert: _vm.revert,
                                                restore: _vm.restore,
                                                load: _vm.load,
                                                fetch: _vm.fetch
                                              },
                                              name: "file",
                                              className: "my-pond",
                                              acceptedFileTypes:
                                                "image/jpeg, image/png",
                                              imagePreviewHeight: "240",
                                              imageCropAspectRatio: "1:1",
                                              labelIdle: "อัพโหลดรูปภาพ",
                                              labelTapToUndo: "",
                                              labelTapToCancel:
                                                "คลิกเพื่อยกเลิก",
                                              labelFileProcessing:
                                                "กำลังอัปโหลด",
                                              labelFileLoading: "กำลังโหลด",
                                              labelFileProcessingComplete: "",
                                              labelButtonRemoveItem: "นำออก",
                                              labelFileProcessingError:
                                                "เกิดข้อผิดพลาด",
                                              labelButtonAbortItemProcessing:
                                                "ยกเลิก"
                                            },
                                            on: { init: _vm.handleFilePondInit }
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "158px",
                                                position: "relative"
                                              }
                                            },
                                            [
                                              [
                                                _vm.shopInfo.logo.original
                                                  ? _c("img", {
                                                      staticClass:
                                                        "col-12 img-thumbnail",
                                                      staticStyle: {
                                                        padding: "5px",
                                                        "max-width": "158px"
                                                      },
                                                      attrs: {
                                                        src:
                                                          _vm.shopInfo.logo
                                                            .original
                                                      }
                                                    })
                                                  : _c("img", {
                                                      staticClass:
                                                        "col-12 img-thumbnail",
                                                      staticStyle: {
                                                        padding: "5px",
                                                        "max-width": "158px"
                                                      },
                                                      attrs: {
                                                        src:
                                                          _vm.defaultImages
                                                            .product
                                                      }
                                                    })
                                              ],
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    position: "absolute",
                                                    top: "5px",
                                                    left: "0px",
                                                    "text-align": "right"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-close-image",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.closeImage()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-times"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                    ]
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.shopname")) + " *"
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.shop_name,
                                    expression: "form.shop_name"
                                  }
                                ],
                                ref: "shopname",
                                staticClass: "form-control",
                                class: [_vm.class_.shop_name],
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.shop_name },
                                on: {
                                  keyup: _vm.onkeyupShopname,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "shop_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.business") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.form")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.info.business.form_id,
                                      expression: "form.info.business.form_id"
                                    }
                                  ],
                                  staticClass: "custom-select form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form.info.business,
                                        "form_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(_vm._s(_vm.$t("placeholder.select")))
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v(_vm._s(_vm.$t("business.form.1")))
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v(_vm._s(_vm.$t("business.form.2")))
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.type")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.info.business.type_id,
                                      expression: "form.info.business.type_id"
                                    }
                                  ],
                                  staticClass: "custom-select form-control",
                                  attrs: {
                                    disabled:
                                      _vm.form.info.business.form_id == ""
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form.info.business,
                                        "type_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(_vm._s(_vm.$t("placeholder.select")))
                                  ]),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "1" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.1"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "2" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.2"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "3" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.3"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "4" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.4"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "5" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.5"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "6" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.6"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "7" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.7"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "8" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.8"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "9" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.9"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "10" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.10"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "11" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.11"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 1
                                    ? _c("option", { attrs: { value: "12" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("business.type.12"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 2
                                    ? _c(
                                        "option",
                                        { attrs: { value: "101" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("business.type.101"))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 2
                                    ? _c(
                                        "option",
                                        { attrs: { value: "102" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("business.type.102"))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id == 2
                                    ? _c(
                                        "option",
                                        { attrs: { value: "103" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("business.type.103"))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.info.business.form_id > 0
                                    ? _c(
                                        "option",
                                        { attrs: { value: "300" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("business.type.300"))
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.about")))
                                ]),
                                _vm._v(" "),
                                _c("b-form-textarea", {
                                  attrs: { rows: 3 },
                                  model: {
                                    value: _vm.form.info.business.about,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.info.business,
                                        "about",
                                        $$v
                                      )
                                    },
                                    expression: "form.info.business.about"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.vat") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.vatregistration"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box-input" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        position: "relative",
                                        top: "1px",
                                        left: "-5px"
                                      },
                                      attrs: { color: "#A3CA76" },
                                      model: {
                                        value: _vm.form.info.vat.is_active,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.info.vat,
                                            "is_active",
                                            $$v
                                          )
                                        },
                                        expression: "form.info.vat.is_active"
                                      }
                                    },
                                    [
                                      [
                                        _vm.form.info.vat.is_active
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.yes"))
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.no"))
                                              )
                                            ])
                                      ]
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.taxpayerno")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.info.vat.taxpayer_no,
                                    expression: "form.info.vat.taxpayer_no"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.form.info.vat.taxpayer_no
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form.info.vat,
                                      "taxpayer_no",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.location") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.country")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.form.info.location.country_code,
                                      expression:
                                        "form.info.location.country_code"
                                    }
                                  ],
                                  staticClass: "custom-select form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form.info.location,
                                        "country_code",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(_vm._s(_vm.$t("placeholder.select")))
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "TH" } }, [
                                    _vm._v(_vm._s(_vm.$t("countries.th")))
                                  ])
                                ]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.address")))
                                ]),
                                _vm._v(" "),
                                _c("b-form-textarea", {
                                  attrs: { rows: 3 },
                                  model: {
                                    value: _vm.form.info.location.address,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.info.location,
                                        "address",
                                        $$v
                                      )
                                    },
                                    expression: "form.info.location.address"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.contacts") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.tel")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.contacts.tel,
                                    expression: "form.contacts.tel"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.contacts.tel },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form.contacts,
                                      "tel",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.email")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.contacts.email,
                                    expression: "form.contacts.email"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.contacts.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form.contacts,
                                      "email",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.socialmedia") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.website")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.contacts.website,
                                    expression: "form.contacts.website"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.contacts.website },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form.contacts,
                                      "website",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("socialmedia.facebook")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.contacts.facebook,
                                    expression: "form.contacts.facebook"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.contacts.facebook },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form.contacts,
                                      "facebook",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("socialmedia.youtube")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.contacts.youtube,
                                    expression: "form.contacts.youtube"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.contacts.youtube },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form.contacts,
                                      "youtube",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "action-bar" }, [
                  !_vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-web",
                            attrs: { disabled: _vm.disabled.btn_save },
                            on: {
                              click: function($event) {
                                return _vm.save()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _vm._m(1)
                      ])
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 right" }, [
      _c("div", { staticClass: "action" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35912ca0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35912ca0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/settings/company/All.vue
// module id = null
// module chunks = 